export const AuthRoutes = {
  SIGN_IN: 'sign-in',
  SIGN_OUT: 'sign-out',
  CALLBACK: 'oauth/callback',
} as const;
